import { Truck } from "lucide-react";
import { mxn } from "@/lib/format";

// Datos del bien en SOLO LECTURA (solicitud sellada y Comité de Crédito).
export function ArrendamientoResumen({ arrendamiento: a, testid = "arrendamiento-resumen" }) {
  if (!a) return null;
  const filas = [
    ["Proveedor", `${a.proveedor_nombre || "—"}${a.proveedor_rfc ? ` · ${a.proveedor_rfc}` : ""}`, "proveedor"],
    ["Bien", `${a.descripcion_bien || "—"} ${a.marca || ""} ${a.modelo || ""} ${a.anio || ""}`.trim(), "bien"],
    ["Número de serie", a.numero_serie || "—", "serie"],
    ["Valor sin IVA", mxn(a.valor_bien_sin_iva), "valor-sin-iva"],
    ["IVA del bien (16%)", mxn(a.iva_bien), "iva-bien"],
    ["Valor con IVA", mxn(a.valor_bien_con_iva), "valor-con-iva"],
    ["Enganche", mxn(a.enganche), "enganche"],
    ["Valor residual", `${a.residual_pct ?? "—"}% · ${mxn(a.valor_residual)}`, "residual"],
    ["Capital a arrendar", mxn(a.capital_arrendar), "capital"],
    ["Plazo", a.plazo ? `${a.plazo} pagos · ${a.periodicidad || "—"}` : "—", "plazo"],
  ];
  return (
    <div data-testid={testid} className="rounded-lg border border-teal-200 bg-teal-50/40 p-3">
      <p className="mb-2 flex items-center gap-2 font-heading text-sm font-semibold text-slate-800">
        <Truck className="h-4 w-4 text-teal-700" /> Datos del bien
      </p>
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
        {filas.map(([l, v, k]) => (
          <div key={k} className="rounded-md border border-slate-100 bg-white p-2">
            <p className="text-[10px] uppercase tracking-wide text-slate-500">{l}</p>
            <p className="mt-0.5 break-words text-sm font-semibold text-slate-800" data-testid={`${testid}-${k}`}>{v}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
